export default __webpack_public_path__ + "static/sweepstakes-prize-06-59f83d69c5ead2e3f846d9afdcd67d66.jpg";